const stack: Array<() => void> = [];

export const dialogStack = {
  push(close: () => void) {
    stack.push(close);
  },
  pop(close: () => void) {
    const index = stack.lastIndexOf(close);

    if (index !== -1) {
      stack.splice(index, 1);
    }
  },
  isTop(close: () => void) {
    return stack[stack.length - 1] === close;
  },
};
